// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2jn29","resendInfoText":"OnGoingPaymentBox_resendInfoText__3bjko"};